<template>
  <v-btn v-bind="$props" v-on="$listeners" :width="width" :small="small" :light="light" :background-color="backgroundColor" :elevation="elevation" :class="isOnMobile ? 'flex-grow-0 pa-1' : 'flex-grow-0 pa-2'" :color="isInDarkMode ? '' : 'white'" :outlined="isInDarkMode" tile :disabled="btnDisabled">
    <slot name="default">
      <v-icon v-if="iconLeft && btnIcon" :color="getButtonColor" small :class="btnText ? 'pr-1' : ''">{{ btnIcon }}</v-icon>
      <span class="ma-0 pa-0" :style="isOnMobile ? 'font-size: 12px;' : ''">{{ btnText }}</span>
      <v-icon v-if="!iconLeft && btnIcon" :color="getButtonColor" small class="pl-1">{{ btnIcon }}</v-icon>
    </slot>
    <!-- <v-btn class="mx-1 mt-0 mb-1 flex-grow-0 elevation-2" :class="isOnMobile?'pa-1':'pa-2'" :color="isInDarkMode ? '' : 'white'" :outlined="isInDarkMode" tile :disabled="btnDisabled"> -->
  </v-btn>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "auto",
    },
    elevation: {
      type: Number,
      default: 2,
    },
    backgroundColor: {
      default: "#fff",
      type: String,
    },
    btnColor: {
      default: null,
      type: String,
    },
    btnText: {
      type: String,
      default: "",
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
    iconLeft: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    btnIcon: {
      type: String,
      default: "mdi-close-octagon",
    },
  },
  data() {
    return {
      buttonColor: this.btnColor,
    };
  },
  computed: {
    getButtonColor() {
      return this.btnColor ?? this.Colors.IconColor;
    },
  },
  mounted() {},
};
</script>
